import { Guid } from "cms-infrastructure-javascriptextensions/Guid";
import { LogItem } from "./LogItem";
import { LogLevel } from "./LogLevel";
import { LogType } from "./LogType";
export class ActivityLogItem extends LogItem {
    /**
     * Initializes a new instance of the `ActivityLogItem` class.
     * @constructor
     * @param Name {string} The name of the activity.
     * @param activityLoggingService {IActivityLoggingService} The activity logging service.
     * @param parentActivityId {string} The activity Id of the parent activity.
     * @param data {any} Any additional JSON data.
     * @param correlationVector? {string} The correlation vector.
     */
    constructor(name, parentActivityId, data, correlationVector) {
        super(name, data, LogType.BeginActivity, Guid.newGuid(), new Date(), parentActivityId);
        this.LogLevel = LogLevel.Activity;
        this.Ended = false;
        this.correlationVector = correlationVector;
    }
}
//# sourceMappingURL=ActivityLogItem.js.map